import axios from "axios";

export const adminApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/admin`, withCredentials: true });

export const money = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} €`;

export const formatDate = (iso) => new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export const errorText = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" ");
  return fallback;
};
